import { useSelector } from 'react-redux'
import { selectUserType } from '@/features/domain/user'

export function useCanSeeTerritorySettings() {
  const userType = useSelector(selectUserType)

  return userType !== 'gpsonly' && userType !== 'guest'
}
